import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { serializeSnProductMappingCreate } from './serialize';

/**
 * 建立待指定 物料序號。
 * POST `/aftersales/sn-product-mapping` → 201。
 *
 * @param {object} payload
 */
export async function createSnProductMapping(payload) {
  const { data: raw } = await request.post(
    '/aftersales/sn-product-mapping',
    serializeSnProductMappingCreate(payload),
  );
  return parseVer4DetailResponse(raw);
}
